<template>
  <div>
    <h3 class="mb-2">Your purchases</h3>
    <hr>
    <app-list :products="products"></app-list>
  </div>
</template>

<script>
import AppList from '@/components/AppList'

export default {
  components: {
    'app-list': AppList
  },
  name: 'ProductsProfile',
  data() {
    return {
      products: []
    }
  },
  created: function() {
    this.fetchData().then(products => (this.products = products))
  },
  methods: {
    fetchData(params) {
      params = params || {}
      return this.$http.get('purchase').then(
        response => {
          return response.data
        },
        response => {
          // error callback
          console.log(response)
        }
      )
    }
  }
}
</script>
<style scoped>
.nav > li > a {
  padding: 10px 15px;
}
.nav > li,
.nav > li > a {
  position: relative;
  display: block;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/profile/ProductsProfile.vue